import SelectItem from "@/models/components/inputs/selectItem";

export enum VOUCHER_TYPE {
  HotelStandard_PL = "HotelStandard_PL",
  HotelStandard_EN = "HotelStandard_EN",
  HotelMIR_PL = "HotelMIR_PL",
  HotelMIR_EN = "HotelMIR_EN",
  HotelOnSpot_PL = "HotelOnSpot_PL",
  HotelOnSpot_EN = "HotelOnSpot_EN",
}

export const voucherTypeSelect = [
  { text: VOUCHER_TYPE.HotelStandard_PL, value: VOUCHER_TYPE.HotelStandard_PL },
  { text: VOUCHER_TYPE.HotelStandard_EN, value: VOUCHER_TYPE.HotelStandard_EN },
  { text: VOUCHER_TYPE.HotelMIR_PL, value: VOUCHER_TYPE.HotelMIR_PL },
  { text: VOUCHER_TYPE.HotelMIR_EN, value: VOUCHER_TYPE.HotelMIR_EN },
  { text: VOUCHER_TYPE.HotelOnSpot_PL, value: VOUCHER_TYPE.HotelOnSpot_PL },
  { text: VOUCHER_TYPE.HotelOnSpot_EN, value: VOUCHER_TYPE.HotelOnSpot_EN },
] as Array<SelectItem>;
